var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "absolute transition-all duration-300",
      style: {
        top: _vm.timeslot.position.top,
        left: _vm.timeslot.position.left
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "pb-2 px-2 flex flex-col justify-between bg-pure-white border border-l-4 rounded-lg shadow-md transition-all duration-300",
          style: {
            height: _vm.timeslot.element.height,
            width: _vm.timeslot.element.width,
            borderColor: _vm.timeslot.element.borderColor
          }
        },
        [
          _vm._l(_vm.timeslot.slots, function(item, idx) {
            return _c("Period", {
              key: item.id,
              attrs: {
                isFirst: idx === 0,
                isCompact: _vm.isCompact,
                slotHeight: _vm.slotHeight,
                item: item,
                isSelected:
                  _vm.selectedSlots.findIndex(function(i) {
                    return i.id === item.id
                  }) > -1,
                isOpenRoom: !_vm.timeslot.title.id
              },
              on: {
                "add-slot": function($event) {
                  return _vm.$emit("add-slot", $event)
                },
                "resume-booking": function($event) {
                  return _vm.$emit("resume-booking", $event)
                },
                "after-commit": function($event) {
                  return _vm.$emit("after-commit")
                }
              }
            })
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "border border-l-4 rounded-t-lg px-4 w-full absolute top-0 left-0 flex items-center justify-center",
              style: {
                height: _vm.isCompact ? "1.25rem" : "1.625rem",
                borderColor: _vm.timeslot.primary_color,
                backgroundColor: _vm.timeslot.secondary_color
              },
              attrs: { title: _vm.timeslot.title.name }
            },
            [
              _c(
                "div",
                { staticClass: "absolute" },
                [
                  _c("BlTooltip", { attrs: { tooltip: _vm.tooltipText } }, [
                    _c("div", {
                      staticClass: "opacity-0",
                      style: {
                        height: _vm.isCompact ? "1.25rem" : "1.625rem",
                        width: "calc(" + _vm.slotWidth + ")"
                      }
                    })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex justify-center truncate" },
                [
                  _c("BlTextBody2", {
                    staticClass: "truncate",
                    style: { color: _vm.timeslot.primary_color },
                    attrs: { text: _vm.timeslot.title.name }
                  })
                ],
                1
              )
            ]
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5993f02b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5993f02b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/timeslot/AvailableTimeslot.vue
// module id = null
// module chunks = 